import initialState from './initialState';
import {
  DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK,
  DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK,
  DASHBOARD_LOGOUT_INIT,
  DASHBOARD_LOGOUT_SUCCESS,
  DASHBOARD_LOGOUT_FAILURE,
  DASHBOARD_GET_USER_PROFILE_INIT,
  DASHBOARD_GET_USER_PROFILE_SUCCESS,
  DASHBOARD_GET_USER_PROFILE_FAILURE,
  DASHBOARD_SET_ACTIVE_MAIN_MENU,
  DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION,
  DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION,
  DASHBOARD_SAVE_ACTUAL_USER_INIT,
  DASHBOARD_SAVE_ACTUAL_USER_SUCCESS,
  DASHBOARD_SAVE_ACTUAL_USER_FAILURE,
  DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY,
  DASHBOARD_SAVE_ACTUAL_USER_RESET,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE,
  DASHBOARD_GET_NOTIFICATIONS_INIT,
  DASHBOARD_GET_NOTIFICATIONS_SUCCESS,
  DASHBOARD_GET_NOTIFICATIONS_FAILURE,
  DASHBOARD_GET_NOTIFICATION_INIT,
  DASHBOARD_GET_NOTIFICATION_SUCCESS,
  DASHBOARD_GET_NOTIFICATION_FAILURE,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE,
	DASHBOARD_DELETE_NOTIFICATION_DATA_INIT,
	DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS,
	DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE,
  DASHBOARD_GET_CUSTOMER_INIT,
  DASHBOARD_GET_CUSTOMER_SUCCESS,
  DASHBOARD_GET_CUSTOMER_FAILURE,
  DASHBOARD_UPDATE_CUSTOMER_INIT,
  DASHBOARD_UPDATE_CUSTOMER_SUCCESS,
  DASHBOARD_UPDATE_CUSTOMER_FAILURE,
  DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY,
  DASHBOARD_UPDATE_CUSTOMER_RESET,
  DASHBOARD_STOP_PROCESS_INIT,
  DASHBOARD_STOP_PROCESS_SUCCESS,
  DASHBOARD_STOP_PROCESS_FAILURE,
  DASHBOARD_GET_PERIODS_LIST_INIT,
  DASHBOARD_GET_PERIODS_LIST_SUCCESS,
  DASHBOARD_GET_PERIODS_LIST_FAILURE,
  DASHBOARD_SET_FIXED_PERIOD_ID,
  DASHBOARD_RESET,
  DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE,
  DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE,
  DASHBOARD_GET_TOURS_STATE_INIT,
  DASHBOARD_GET_TOURS_STATE_SUCCESS,
  DASHBOARD_GET_TOURS_STATE_FAILURE,
  DASHBOARD_SET_TOURS_STATE_INIT,
  DASHBOARD_SET_TOURS_STATE_SUCCESS,
  DASHBOARD_SET_TOURS_STATE_FAILURE,
  DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE,
  DASHBOARD_SAVE_USER_IMAGE_INIT,
  DASHBOARD_SAVE_USER_IMAGE_SUCCESS,
  DASHBOARD_SAVE_USER_IMAGE_FAILURE,
} from '../../actions/dashboard/types';
import Constants from '../../../definitions/constants';
import MenuTooling from '../../../tooling/menuTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function dashboard(state = initialState, action) {
  switch (action.type) {   
    case DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK:
      var elementStates = JavascriptUtilsTooling.deepCopy(state.mainMenu.elementStates);
      //manage parents open/closed state and childs active state.      
      if(action.payload.itemParent) {
        MenuTooling.manageOpenState(elementStates, action.payload.itemKey);
      }
      else {
        MenuTooling.manageActiveState(elementStates, action.payload.itemKey);
      }
      return {
        ...state,
        mainMenu : {
          ...state.mainMenu,
          elementStates: elementStates
        }
      };
    case DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK:
      var elementStates = JavascriptUtilsTooling.deepCopy(state.topMenu.elementStates);
      MenuTooling.manageActiveState(elementStates, action.payload.itemKey);
      return {
        ...state,
        topMenu : {
          ...state.topMenu,
          elementStates: elementStates
        }
      };
    case DASHBOARD_SET_ACTIVE_MAIN_MENU: 
      var elementStates = JavascriptUtilsTooling.deepCopy(state.mainMenu.elementStates);  
      MenuTooling.setActiveMenu(elementStates,action.payload.route);
      return {
        ...state,
        mainMenu : {
          ...state.mainMenu,
          elementStates: elementStates
        }
      };
    case DASHBOARD_LOGOUT_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "logout");
    case DASHBOARD_LOGOUT_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "logout");
    case DASHBOARD_LOGOUT_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "logout");
    case DASHBOARD_GET_USER_PROFILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "userProfile");
    case DASHBOARD_GET_USER_PROFILE_SUCCESS:
      var elementStatesMainMenu = MenuTooling.getInitialMenuStates(state.mainMenu.elements);
      var elementStatesTopMenu = MenuTooling.getInitialMenuStates(state.topMenu.elements);
      var userProfileRole = action.payload.data.role;
      
      if(userProfileRole === Constants.app.userRoles.USER) {
        elementStatesMainMenu[Constants.app.menuKeys.HOME].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.NOTIFICATIONS].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.CHANGE_PASSWORD].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION_LOGOUT].enabled = true;        
        elementStatesTopMenu[Constants.app.menuKeys.TOUR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SHOW_TOUR].enabled = true;
      }
      else if(userProfileRole === Constants.app.userRoles.ADMIN) {
        elementStatesMainMenu[Constants.app.menuKeys.HOME].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_USERS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CALCULATION_UNIT_PARENT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CALCULATION_UNIT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_GROUP].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_GROUP].enabled = true;   
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_POLYNOMIAL_GROUP].enabled = true;  
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_POLYNOMIAL_CALCULATION_UNIT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_DIMENSION].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_METRIC].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_VIRTUAL_METRIC].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_METRICS_GROUP].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_POLYNOMIAL].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS_PANEL].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS_ADMIN].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS_VARIABLES_ADMIN].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_ACTUAL_PERIOD].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_CLOSED_PERIODS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_HISTORY].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.PRE_CALCULATIONS_HISTORY].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_METRIC_DATA].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.REPORT_TEMPLATES].enabled = true;
		    elementStatesMainMenu[Constants.app.menuKeys.ADMIN_REPORT_TEMPLATES].enabled = true;
		    elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_REPORT_TEMPLATE_GROUP].enabled = true;
		    elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_REPORT_TEMPLATE_CALCULATION_UNIT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_BI_TEMPLATES].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.BI_REPORTS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.BI_CALCULATIONS_SUMMARY].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_SUPERVISORS_REVISIONS_PANEL].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.EXPORT_CONFIGURATIONS_ADMIN].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.TOUR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SHOW_TOUR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.NOTIFICATIONS].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.CHANGE_PASSWORD].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.UPDATE_CUSTOMER].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.CALENDAR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION_LOGOUT].enabled = true;
      }
      else if(userProfileRole === Constants.app.userRoles.PERIOD_ADMIN) {
        elementStatesMainMenu[Constants.app.menuKeys.HOME].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CALCULATION_UNIT_PARENT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CALCULATION_UNIT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_GROUP].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_GROUP].enabled = true;   
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_POLYNOMIAL_GROUP].enabled = true;  
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_ASSIGN_POLYNOMIAL_CALCULATION_UNIT].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_ACTUAL_PERIOD].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_CLOSED_PERIODS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.CALCULATIONS_HISTORY].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.PRE_CALCULATIONS_HISTORY].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_CONFIG_METRIC_DATA].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.ENDPOINTS_CONNECTORS_PANEL].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.BI_REPORTS].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.BI_CALCULATIONS_SUMMARY].enabled = true; 
        elementStatesMainMenu[Constants.app.menuKeys.ADMIN_SUPERVISORS_REVISIONS_PANEL].enabled = true;        
        elementStatesMainMenu[Constants.app.menuKeys.EXPORT_CONFIGURATIONS_ADMIN].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.NOTIFICATIONS].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.CHANGE_PASSWORD].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION_LOGOUT].enabled = true;        
        elementStatesTopMenu[Constants.app.menuKeys.TOUR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SHOW_TOUR].enabled = true;
      }
      else if(userProfileRole === Constants.app.userRoles.SUPERVISOR) {        
        elementStatesMainMenu[Constants.app.menuKeys.HOME].enabled = true;
        elementStatesMainMenu[Constants.app.menuKeys.SUPERVISOR_REVISION_PANEL].enabled = true;        
        elementStatesTopMenu[Constants.app.menuKeys.SESSION].enabled = true;        
        elementStatesTopMenu[Constants.app.menuKeys.NOTIFICATIONS].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.CHANGE_PASSWORD].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SESSION_LOGOUT].enabled = true;        
        elementStatesTopMenu[Constants.app.menuKeys.TOUR].enabled = true;
        elementStatesTopMenu[Constants.app.menuKeys.SHOW_TOUR].enabled = true;        
      }
      
      return{
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "userProfile")),
        unAuthorized:(action.payload.status == 401) ? true : false,
        mainMenu : {
          ...state.mainMenu,
          elementStates: elementStatesMainMenu
        },
        topMenu : {
          ...state.topMenu,
          elementStates: elementStatesTopMenu
        }
      };
    case DASHBOARD_GET_USER_PROFILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "userProfile");
    case DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION:
      return {
        ...state,
        onScrollBottomAction: action.payload.action
      };
    case DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION:
      return {
        ...state,
        onScrollBottomAction: null
      };
     case DASHBOARD_SAVE_ACTUAL_USER_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "saveActualUser");
    case DASHBOARD_SAVE_ACTUAL_USER_SUCCESS:
      return{
        ...(ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "saveActualUser")),
        unAuthorized:(action.payload.status == 401) ? true : false,
      };
    case DASHBOARD_SAVE_ACTUAL_USER_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "saveActualUser");
    case DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "saveActualUser");
    case DASHBOARD_SAVE_ACTUAL_USER_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "saveActualUser");    
    case DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT:
      var newState = ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "notViewedNotificationsCount");
      newState.notViewedNotificationsCount.data = state.notViewedNotificationsCount.data
      return newState;
    case DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "notViewedNotificationsCount");
    case DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "notViewedNotificationsCount"); 
    case DASHBOARD_GET_NOTIFICATIONS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "notifications");
    case DASHBOARD_GET_NOTIFICATIONS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "notifications");
    case DASHBOARD_GET_NOTIFICATIONS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "notifications");
    case DASHBOARD_GET_NOTIFICATION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "notification");
    case DASHBOARD_GET_NOTIFICATION_SUCCESS:
      var newState = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "notification");
      if(action.payload.status == 200 && newState.notifications.data) {
        newState.notifications.data.map(item => {
          if(newState.notification.data.id == item.id) {
            item.viewed_state = Constants.notifications.VIEWED_STATE;
          }
          return item;
        });
      }
      return newState;
    case DASHBOARD_GET_NOTIFICATION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "notification");
    case DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadNotificationFile");
    case DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadNotificationFile");
    case DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadNotificationFile");
    case DASHBOARD_DELETE_NOTIFICATION_DATA_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "deleteNotificationData");
    case DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS:
      var newState = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "deleteNotificationData");
      if(action.payload.status == 200 && newState.notifications.data) {
        newState.notifications.data.map(item => {
          if(newState.notification.data.id == item.id) {
            item.process_state = Constants.notifications.DATA_DELETED_STATE;
          }
          return item;
        });
      }
      return newState;
    case DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "deleteNotificationData");
    case DASHBOARD_RESET:
      return initialState;
    case DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE:
      return {
        ...state,
        handleNotificationDetailPopupReference: action.payload
      };
    case DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE:
      return {
        ...state,
        handleCheckRouteAvailableTourReference: action.payload
      };
    case DASHBOARD_GET_CUSTOMER_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "getCustomer");
    case DASHBOARD_GET_CUSTOMER_SUCCESS:
      return{
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "getCustomer")),
        unAuthorized:(action.payload.status == 401) ? true : false,
      };
    case DASHBOARD_GET_CUSTOMER_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "getCustomer");
    case DASHBOARD_UPDATE_CUSTOMER_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "updateCustomer");
    case DASHBOARD_UPDATE_CUSTOMER_SUCCESS:
      return{
        ...(ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "updateCustomer")),
        unAuthorized:(action.payload.status == 401) ? true : false,
      };
    case DASHBOARD_UPDATE_CUSTOMER_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "updateCustomer");
    case DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "updateCustomer");
    case DASHBOARD_UPDATE_CUSTOMER_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "updateCustomer");  
    case DASHBOARD_STOP_PROCESS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "stopProcess");
    case DASHBOARD_STOP_PROCESS_SUCCESS:
      var newState = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "stopProcess");
      if(action.payload.status == 200 && newState.notifications.data) {
        newState.notifications.data.map(item => {
          if(newState.notification.data.id == item.id) {
            item.process_state = Constants.notifications.PROCESSING_STOP_PROCESS_STATE;
          }
          return item;
        });
      }
      return newState;
    case DASHBOARD_STOP_PROCESS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "stopProcess");
    case DASHBOARD_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case DASHBOARD_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case DASHBOARD_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");
    case DASHBOARD_SET_FIXED_PERIOD_ID:
      return {
        ...state,
        fixedPeriodId: action.id
      };
    case DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "setAllNotificationsViewed");
    case DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "setAllNotificationsViewed");
    case DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "setAllNotificationsViewed");

    case DASHBOARD_GET_TOURS_STATE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "getToursState");
    case DASHBOARD_GET_TOURS_STATE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "getToursState");
    case DASHBOARD_GET_TOURS_STATE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "getToursState");
      
    case DASHBOARD_SET_TOURS_STATE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "setToursStates");
    case DASHBOARD_SET_TOURS_STATE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "setToursStates");
    case DASHBOARD_SET_TOURS_STATE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "setToursStates");   

    case DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE:
      return {
        ...state,
        tourFunction: action.payload
      };

    case DASHBOARD_SAVE_USER_IMAGE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "saveUserImage");
    case DASHBOARD_SAVE_USER_IMAGE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "saveUserImage");
    case DASHBOARD_SAVE_USER_IMAGE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "saveUserImage");

    default:
      return ((action && action.payload && action.payload.status && action.payload.status == 401) ? 
        {...state, unAuthorized: true} : state
      );
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/dashboard/index.js